module.exports = __webpack_public_path__ + "img/nav_pic02.d8138566.png";